import cx from 'classnames';
import React from 'react';

import { formatDate } from '../../../lib/helpers';
import Button from '../Button/Button';
import ButtonGroup from '../ButtonGroup/ButtonGroup';
import { Download } from '../Icon';
import * as styles from './DownloadCard.module.css';

const DownloadCard = ({
	title,
	date,
	file,
	as: Component = 'div',
	className = '',
	children,
}: {
	title: string;
	date?: string;
	file: string;
	as?: React.ElementType;
	className?: string;
	children?: React.ReactNode;
}) => {
	return (
		<Component className={cx(styles.card, className)}>
			<div className={styles.bounds}>
				<div className={styles.content}>
					<h3>{title}</h3>
					{date && <p className={styles.date}>{formatDate(date)}</p>}
					{children}
				</div>
				<ButtonGroup align="center" stretch>
					<Button to={file} theme="inverted" download>
						Download PDF <Download />
					</Button>
				</ButtonGroup>
			</div>
		</Component>
	);
};

export default DownloadCard;
